import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// One traveller's request. PostFunction shows the server's message on failure
// and throws; callers keep what is on screen and offer Retry.
// Both screens that read a request say "did not load" on the page: no toast.
export const getRequest = (id, dispatch) =>
  PostFunction({ Route: UrlApi.requests.get_one, data: { id }, isMultipart: false, showalert: false, showerror: false, dispatch });

// "2027-12-31 00:00:00" or a Date to the "YYYY-MM-DD" the server stores.
export function isoDay(value) {
  if (!value) return "";
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  return m ? `${m[1]}-${m[2]}-${m[3]}` : "";
}

// request/update-request, the classic edit. What the server does with it:
//  - one email that says what happened: "Your <country> visa is approved"
//    (status approved + a visa file), "… visa is ready" (a visa alone), or
//    "Application <id>: <status>" (a status alone);
//  - every call rewrites the visa's expiry date, to empty when none is sent,
//    so the current expiry always goes along;
//  - a missing visa field leaves the uploaded visa as it is.
//  - notify:false saves without any email (the answer's data.emailed says
//    whether one went out; false also when the mail server refused).
//  - isPaid 1 records a payment taken outside the website: paymentMethod
//    "cash" (the default) or "transfer", an optional paymentReference and
//    paidOn ("YYYY-MM-DD", the day it came in); isPaid 0 marks it not paid.
export const updateRequest = ({ id, status, isPaid, paymentMethod, paymentReference, paidOn, visaFile, expireAt, notify = true, quiet = false }, dispatch) => {
  const body = new FormData();
  body.append("id", id);
  if (status) body.append("status", status);
  if (notify === false) body.append("notify", "false");
  if (isPaid === 0 || isPaid === 1) body.append("is_paid", isPaid);
  if (isPaid === 1 && paymentMethod) body.append("payment_method", paymentMethod);
  if (isPaid === 1 && paymentReference) body.append("payment_reference", paymentReference);
  if (isPaid === 1 && paidOn) body.append("paid_on", paidOn);
  if (visaFile instanceof File) body.append("visa", visaFile);
  const day = isoDay(expireAt);
  if (day) body.append("expire_at", day);
  return PostFunction({ Route: UrlApi.requests.update_request, data: body, isMultipart: true, showalert: !quiet, dispatch });
};
